import { gql } from '@apollo/client';
export const DeleteLeaveSubtype = gql `
    mutation DeleteLeaveSubtype($leaveSubTypeIds: [StaffLeaveSubTypeId!]!) {
        staffhours {
            leaves {
                subtypes {
                    delete(leaveSubTypeIds: $leaveSubTypeIds)
                }
            }
        }
    }
`;
